import * as core from '../../../../../../../core'

import { query } from './proposal-attributes.query'

export const RESOURCE = {
  payload: {
    alias: 'proposal.attributes',
    description: 'Details widget showing attributes of a proposal',
    name: 'Proposal Attributes',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
